module.exports = __webpack_public_path__ + "img/pause-right.0e0c3ca9.svg";